module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentaa"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Generations to come, it may be, will scarce believe that such a one as this ever in flesh and blood walked upon this earth.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "rightg1"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INSTEIN")]), _vm._v(" on Gandhi.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Mahatma Gandhi will go down in history on a par with Buddha and Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "rightg1"
  }, [_vm._v("—V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISCOUNT")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUIS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUNTBATTEN, THE LAST")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RITISH")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICEROY OF")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDIA.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("We did not conquer India for the benefit of the Indians. We conquered India as the outlet for the goods of Great Britain. We conquered India by the sword, and by the sword we should hold it.")])]), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("—L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RENTFORD,")]), _vm._v(" 1930.")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 72
// module chunks = 0